import { Button } from "@chakra-ui/react";
import React from "react";
export const ThemedButton = (props) => (React.createElement(Button, Object.assign({}, props, { bg: "reaBlue.800", color: "white", _hover: { bg: "reaBlue.700" }, borderRadius: 0 })));
